
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class Select extends Vue {
  @Prop({ default: '' }) readonly label!: any
  @Prop({ default: '' }) readonly icon!: string

  get isRequired() {
    const rules = this.$attrs.rules || []
    if (Array.isArray(rules)) {
      return rules.some((rule: Function) => {
        return typeof rule === 'function' && rule?.name?.includes('required')
      })
    }
    return false
  }

  get listeners() {
    return {
      ...this.$listeners,
      input: (value: unknown) => {
        this.$emit('input', value)
      },
    }
  }
}
